export const environment = {
  production: true,
  company: 'demo',
  APIUrl: 'https://mcg.demo.backend.jbmsoftware.nl/',
  SocketIO_EndPoint: 'https://mcg.demo.backend.jbmsoftware.nl',
  RecipeAppSupport:false
};

